import React from 'react';
import { MuiGrid, MuiTypography, MuiButton, MuiInfoIcon } from '../../../ui/MaterialUIComponents';
import theme from '../../../../assests/theme'

import { logMessageEval } from '../../../../utils/EvaluationUtil'
function LogItemCard(props) {
	let logItem = props.logItem;
	let index = props.index + 1;
	return (
		<MuiGrid container xs={12} style={{
			background: props.errorItemIndex == props.index ? theme.palette.error.light : "none",
			padding: 4,
			borderBottom: props.errorItemIndex == props.index ? 'none' : '1px solid grey',
			cursor: (logItem.messageItem.SUB_GRP != undefined) ? 'pointer' : 'default'
		}}
			onClick={logItem.messageItem.SUB_GRP != undefined ? () => props.selectErrorItem(props.index) : null}
		>
			<MuiGrid xs style={{ wordBreak: 'break-word' }}

			>
				<MuiTypography variant={theme.typographyStyles.BODY1} style={{ color:theme.palette.primary.dark }}>
					<span style={{ fontWeight: 600 }}>{index}.{logItem.logType} : </span>
					{logItem.messagetype}
				</MuiTypography>
				<MuiTypography color='primary' variant={theme.typographyStyles.CAPTION} style={{ color:theme.palette.primary.dark }}>
					{(logItem.messageItem !== undefined && logItem.messageItem.message !== undefined) ? logMessageEval(logItem.messageItem.message, logItem.messageItem) : ''}
				</MuiTypography>
				<MuiTypography color='primary' variant={theme.typographyStyles.CAPTION} style={{ color: theme.palette.primary.dark }}>
					{(logItem.hint !== "" && logItem.messageItem.message !== undefined) ? " Hint: "+logMessageEval(logItem.hint, logItem.messageItem) : ''}
				</MuiTypography>
			</MuiGrid>
			{logItem.messageItem.SUB_GRP != undefined &&
				<MuiGrid style={{ padding: 4, boxSizing: 'border-box' }}>
					<MuiInfoIcon color='error' size='small'/>
				</MuiGrid>
			}
		</MuiGrid>
	)

}

export default LogItemCard;